import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { ThemeManifestPage } from "@javascript/components/developer-docs/ThemeManifestPage"

interface ThemeManifestContent {
  pages: DeveloperDocsPage[]
  themeJsonExample: string
}

export default function ThemeManifest() {
  const { pages, themeJsonExample } = useContent<ThemeManifestContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/theme-manifest">
      <ThemeManifestPage themeJsonExample={themeJsonExample} />
    </DeveloperDocsLayout>
  )
}
